module.exports = __webpack_public_path__ + "57695a49bda05910f2aa2e5eb73aa4db.png";